"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.HbMessageDataField = void 0;
const EditorFieldBase_1 = require("./EditorFieldBase");
class HbMessageDataField extends EditorFieldBase_1.EditorFieldBase {
}
exports.HbMessageDataField = HbMessageDataField;
